module.exports = __webpack_public_path__ + "static/media/white-bed.5e23146a.svg";